export const INITIAL_STATE = {
  buildingId: '',
  name: '',
  floorNumber: '',
};
